import React, {useState, useContext, useEffect} from 'react'
import Pie from './Pie'
import AppContext from '../../../contexts/app-context';
import AuthContext from '../../../contexts/auth-context';
import useAxios from '../../../hooks/useAxios';
import { urls } from '../../config/variables';

const State = () => {
  // const data = [
  //   { "state": "Rejected", "state_count": 7, "count": 7 },
  //   { "state": "Approved", "state_count": 1, "count": 1 },
  // ];

    const { globalFilterQuery } = useContext(AppContext);
    const { token } = useContext(AuthContext);
    const { operation } = useAxios();
  
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
  
    const fetchData = () => {
      operation(
        {
          method: 'GET',
          url: urls.ANALYSIS_ENCOUNTERS + (globalFilterQuery || ''),
          headers: { Authorization: `token ${token}` },
        },
        (data) => {
          setData(data);
          setLoading(false);
        },
        (err) => {
          setData([]);
          setLoading(false);
        }
      );
    }
  
    useEffect(() => {
      if (token) {
        fetchData();
      }
      // eslint-disable-next-line
    }, [globalFilterQuery, token]) 

  const customColors = {
    'Approved': '#4CAF50',
    'Partially accepted': '#FFC107',
    'Rejected': '#F44336',
  };

  // reformate data to fit pie chart component data format.
  const formattedData = data
  .map(item => ({
    label: item.state,
    count: item.state_count,
  }))
  .sort((a, b) => b.count - a.count);

  // Take top 10 to show in pie chart, the rest will be shown in details dialog.
  const top = formattedData.slice(0, 10);

  return (
    <Pie
      chartId='state'
      data={formattedData}
      top={top}
      loading={loading}
      customColors={customColors}
      showLegend={true}
      showDetailsDialog={false}
      pieTitle="Encounter State"
      pieCenterLabel="Encounter"
      dialogButtonLabel="Details"
      dialogTitle="State Details"
    />
  )
}

export default State